import type { I_Playbook, Playbooks } from '@eureka/services/src/types/playbook';
import type { IQueryRoot } from '@eureka/services/src/types/query';

export interface PreviewApiRequest {
    playbook: I_Playbook,
    q_s?: IQueryRoot | null,
}

export interface PreviewApiResponse {
    playbook: Playbooks,
    qid: string,
    q?: string,
    novelty_id?: string,
}

export const SearchResultApi = Symbol('SearchResultApi');

export interface SearchResultApi {
    preview(data: PreviewApiRequest): Promise<PreviewApiResponse>;
}
